.gray-background{width:100vw;height:100vh;position:fixed;opacity:.5;background:#000;z-index:1000;top:0;left:0}.save-spinner{position:absolute;left:calc(50vw - 12px);top:calc(50vh - 12px);z-index:1003;color:#d3d3d3}
/*# sourceMappingURL=filter-profile-spinner.component-VL334PUJ.css.map */
